function reorderAddToCartApp() {
  return {
    show: false,
    fullfilledItems: [],
    rejectedItems: [],
    heading: 'Reorder',
    init() {
      document.addEventListener('itemsReordered', (e) => {
        this.fullfilledItems = e.detail._fullfilled;
        this.rejectedItems = e.detail._rejected;
        this.show = true;
      });
    },
  };
}
